import { apiFetch } from "./client";

const BASE_URL = import.meta.env.VITE_API_URL;

export interface User {
	id: string;
	email: string;
	subscriptionId: string;
}

interface UserResponse {
	ok: boolean;
	user: User;
}

export async function getMe(): Promise<UserResponse> {
	const res = await apiFetch(`${BASE_URL}/user/me`, { method: "GET" });
	return await res.json();
}
